// Banco Extenso de Razonamiento e Inteligencia Psicométrica UNINAV 2026
// Evaluaciones tipo Raven (Matrices Progresivas), Beta-III, Wonderlic y Razonamiento Mecánico Bennett.

export const PSICOMETRICO_QUESTIONS = [
  // ── 1. RAZONAMIENTO ABSTRACTO Y MATRICES LÓGICAS (TIPO RAVEN) ──
  {
    id: "psi_01",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Identifica la figura que continúa lógicamente la secuencia de rotación y elementos internos: Un cuadrado tiene un triángulo negro en el vértice superior izquierdo en la figura 1, en el superior derecho en la figura 2, y en el inferior derecho en la figura 3.",
    options: [
      "Vértice inferior izquierdo (el triángulo negro rota 90° en sentido horario)",
      "Centro del cuadrado con inversión de color",
      "Vértice superior izquierdo reiniciando el ciclo"
    ],
    correct_index: 0,
    explanation: "El elemento describe un desplazamiento continuo por los cuatro vértices del cuadrado en sentido de las manecillas del reloj (90° por paso). Tras el inferior derecho (Fig. 3), corresponde el inferior izquierdo."
  },
  {
    id: "psi_02",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "En una matriz de 3x3, la fila 1 contiene: 1 círculo con 1 cruz, 1 círculo con 2 cruces, 1 círculo con 3 cruces. La fila 2 contiene: 1 cuadrado con 2 líneas, 1 cuadrado con 4 líneas, 1 cuadrado con 6 líneas. La fila 3 contiene: 1 triángulo con 3 puntos, 1 triángulo con 6 puntos, ¿qué figura completa la matriz?",
    options: [
      "1 triángulo con 9 puntos (progresión aritmética +3 puntos por casilla)",
      "1 triángulo con 8 puntos",
      "1 cuadrado con 9 puntos"
    ],
    correct_index: 0,
    explanation: "En la tercera fila la regla es multiplicar por el orden de la columna: columna 1 tiene 3 puntos (3*1), columna 2 tiene 6 puntos (3*2), por tanto la columna 3 debe tener 9 puntos (3*3) manteniendo la forma geométrica de triángulo."
  },
  {
    id: "psi_03",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "¿Qué figura no pertenece al grupo por simetría y patrón?",
    options: [
      "Una flecha orientada en diagonal con punta doble asimétrica",
      "Un pentágono regular con eje de simetría vertical",
      "Un hexágono regular con simetría central"
    ],
    correct_index: 0,
    explanation: "El pentágono y el hexágono son polígonos regulares que poseen ejes de simetría definidos; la figura con punta doble asimétrica rompe la invariancia geométrica del conjunto."
  },
  {
    id: "psi_04",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Se superponen dos figuras transparentes: una contiene líneas horizontales negras y la otra contiene líneas verticales rojas. La regla de combinación indica que la intersección genera una cuadrícula punteada. Si a continuación se añade una tercera capa con círculos concéntricos, ¿cuál es el resultado lógico?",
    options: [
      "Una cuadrícula punteada con anillos concéntricos superpuestos en cada nodo",
      "Las líneas horizontales desaparecen por saturación",
      "Una elipse sólida que anula las líneas previas"
    ],
    correct_index: 0,
    explanation: "En las pruebas de superposición lógica de capas transparentes, los elementos aditivos se conservan en sus respectivos planos sin destruir la estructura preexistente."
  },

  // ── 2. APTITUD MECÁNICA Y FÍSICA APLICADA (TIPO BENNETT / POLEAS / ENGRANES) ──
  {
    id: "psi_05",
    category: "Aptitud Mecánica",
    battery: "Bennett / Mecánica Naval",
    question: "Se tienen tres engranajes conectados en serie: A (30 dientes), B (15 dientes) y C (60 dientes). Si el engranaje A gira en sentido horario a 100 RPM, ¿en qué sentido y a qué velocidad gira el engranaje C?",
    options: [
      "Sentido horario a 50 RPM",
      "Sentido antihorario a 100 RPM",
      "Sentido horario a 200 RPM"
    ],
    correct_index: 0,
    explanation: "A (horario) invierte a B (antihorario), y B invierte a C (horario). RPM_C = RPM_A * (Dientes_A / Dientes_C) = 100 * (30 / 60) = 50 RPM."
  },
  {
    id: "psi_06",
    category: "Aptitud Mecánica",
    battery: "Bennett / Mecánica Naval",
    question: "En un polipasto o aparejo de poleas que cuenta con 2 poleas fijas y 2 poleas móviles con 4 tramos de cuerda que sostienen la carga directamente, ¿cuánta fuerza se requiere aplicar para levantar una carga de 400 kgf?",
    options: [
      "100 kgf (Fuerza = Carga / número de tramos móviles = 400 / 4)",
      "200 kgf",
      "50 kgf"
    ],
    correct_index: 0,
    explanation: "La ventaja mecánica de un aparejo con 4 ramales que sostienen la carga móvil es de 4 a 1. Por tanto, F = R / 4 = 400 kgf / 4 = 100 kgf."
  },
  {
    id: "psi_07",
    category: "Aptitud Mecánica",
    battery: "Bennett / Mecánica Naval",
    question: "En una palanca de primer género, se desea levantar una carga de 300 kg situada a 1 metro del punto de apoyo. Si la fuerza se aplica a 3 metros del punto de apoyo, ¿cuántos kg de fuerza se requieren para equilibrarla?",
    options: [
      "100 kg (Ley de la Palanca: F1 * d1 = F2 * d2)",
      "150 kg",
      "300 kg"
    ],
    correct_index: 0,
    explanation: "Potencia * Brazo de Potencia = Resistencia * Brazo de Resistencia. F * 3 m = 300 kg * 1 m ==> F = 300 / 3 = 100 kg."
  },
  {
    id: "psi_08",
    category: "Aptitud Mecánica",
    battery: "Bennett / Mecánica Naval",
    question: "Un buque ingresa de agua salada (densidad 1.025 g/cm³) a un río de agua dulce (densidad 1.000 g/cm³). Por el principio de Arquímedes, ¿qué ocurrirá con el calado del buque (la profundidad sumergida del casco)?",
    options: [
      "El calado aumentará (el buque se hundirá un poco más debido a la menor densidad del agua dulce)",
      "El calado disminuirá (el buque flotará más alto)",
      "El calado permanecerá exactamente inalterado"
    ],
    correct_index: 0,
    explanation: "Al ser el agua dulce menos densa, se requiere un mayor volumen de agua desalojada para igualar el peso total del buque, por lo que el calado aumenta."
  },
  {
    id: "psi_09",
    category: "Aptitud Mecánica",
    battery: "Bennett / Mecánica Naval",
    question: "¿En cuál de los dos recipientes cilíndricos habrá mayor presión hidrostática en el fondo si ambos contienen agua de mar: el recipiente A (ancho de 2 metros y profundidad de 5 metros) o el recipiente B (ancho de 1 metro y profundidad de 10 metros)?",
    options: [
      "El recipiente B (la presión depende exclusivamente de la profundidad P = ρ * g * h)",
      "El recipiente A (al tener mayor diámetro soporta más volumen)",
      "Ambos recipientes tienen exactamente la misma presión"
    ],
    correct_index: 0,
    explanation: "La presión hidrostática en un fluido estático depende únicamente de la densidad del fluido, la gravedad y la profundidad (h). El recipiente B tiene el doble de profundidad (10 m vs 5 m), por lo que su presión en el fondo es el doble."
  },

  // ── 3. VISUALIZACIÓN Y ORIENTACIÓN ESPACIAL 3D (CUBOS Y DESPLIEGUES) ──
  {
    id: "psi_10",
    category: "Aptitud Espacial",
    battery: "Beta-III / Espacial",
    question: "Si se dobla el desarrollo plano tradicional en forma de cruz latina de un cubo, ¿qué caras quedan exactamente opuestas?",
    options: [
      "Las caras separadas por una sola cara intermedia en el eje de la cruz",
      "Las caras adyacentes que comparten un doblez",
      "Las caras situadas en los extremos de los brazos horizontales opuestos"
    ],
    correct_index: 0,
    explanation: "En la geometría de cubos desdoblados, dos caras son estrictamente opuestas si están alineadas con una sola cara intermedia entre ellas en el patrón desplegado."
  },
  {
    id: "psi_11",
    category: "Aptitud Espacial",
    battery: "Beta-III / Espacial",
    question: "Un dado regular tiene sus caras opuestas sumando siempre 7. Si la cara superior muestra el 5 y la cara que mira al norte muestra el 3, ¿qué número está en la cara inferior y qué número mira al sur?",
    options: [
      "Inferior: 2 (7 - 5); Sur: 4 (7 - 3)",
      "Inferior: 1; Sur: 6",
      "Inferior: 3; Sur: 5"
    ],
    correct_index: 0,
    explanation: "Por regla estándar de dados: 5 opuesto a 2 (5+2=7), 3 opuesto a 4 (3+4=7)."
  },
  {
    id: "psi_12",
    category: "Aptitud Espacial",
    battery: "Beta-III / Espacial",
    question: "Si una figura tridimensional en forma de 'L' se rota 180° en el plano horizontal y posteriormente 90° hacia adelante en el plano vertical, ¿cuál será su orientación resultante?",
    options: [
      "La base apunta hacia el observador y el brazo vertical queda hacia la izquierda",
      "La figura vuelve a su posición original de referencia",
      "La base apunta hacia arriba con inversión de simetría"
    ],
    correct_index: 0,
    explanation: "La rotación de 180° horizontal invierte derecha/izquierda y frente/fondo. Al volcar 90° hacia adelante, la cara superior se convierte en el frente visible hacia el sustentante."
  },
  {
    id: "psi_13",
    category: "Aptitud Espacial",
    battery: "Beta-III / Espacial",
    question: "Se observa un bloque sólido compuesto por 27 cubos pequeños formando un cubo de 3x3x3. Si se pintan de azul todas las caras exteriores del cubo grande, ¿cuántos cubos pequeños tendrán exactamente 2 caras pintadas de azul?",
    options: [
      "12 cubos (los cubos ubicados en el centro de las 12 aristas)",
      "8 cubos (los vértices)",
      "6 cubos (los centros de las caras)"
    ],
    correct_index: 0,
    explanation: "En un cubo de 3x3x3: los vértices (8) tienen 3 caras pintadas; el centro de cada arista (1 por arista * 12 aristas = 12 cubos) tiene exactamente 2 caras pintadas; el centro de cada cara exterior (6) tiene 1 cara pintada; el cubo central interior (1) tiene 0 caras pintadas."
  },

  // ── 4. SERIES NUMÉRICAS Y ALFANUMÉRICAS RÁPIDAS (TIPO WONDERLIC) ──
  {
    id: "psi_14",
    category: "Series Numéricas",
    battery: "Wonderlic",
    question: "¿Qué número continúa la serie lógica: 3, 7, 15, 31, 63, ...?",
    options: [
      "127 (la regla es: término * 2 + 1)",
      "126 (la regla es: duplicar el valor previo)",
      "120 (la regla es: sumar múltiplos de diez)"
    ],
    correct_index: 0,
    explanation: "Cada término es el doble del anterior más 1 (3*2+1=7, 7*2+1=15, 15*2+1=31, 31*2+1=63, 63*2+1 = 127). También equivale a sumar potencias de 2 (+4, +8, +16, +32, +64)."
  },
  {
    id: "psi_15",
    category: "Series Numéricas",
    battery: "Wonderlic",
    question: "¿Qué número continúa la secuencia alternada: 4, 18, 8, 14, 12, 10, 16, ...?",
    options: [
      "6 (serie alternada: serie par suma 4: 4,8,12,16; serie impar resta 4: 18,14,10, 6)",
      "8",
      "12"
    ],
    correct_index: 0,
    explanation: "Es una serie intercalada: Posiciones impares: 4, 8, 12, 16 (+4). Posiciones pares: 18, 14, 10, ... resta 4 en cada paso (10 - 4 = 6)."
  },
  {
    id: "psi_16",
    category: "Series Numéricas",
    battery: "Wonderlic",
    question: "¿Qué letra y número continúan la serie alfanumérica: B-2, D-4, G-7, K-11, ...?",
    options: [
      "P-16 (los números son la posición en el abecedario: +2, +3, +4, +5 -> 11 + 5 = 16 = P)",
      "O-15",
      "Q-17"
    ],
    correct_index: 0,
    explanation: "El incremento entre las posiciones alfabéticas es creciente: B (2) a D (4) = +2; D (4) a G (7) = +3; G (7) a K (11) = +4; por lo tanto, siguiente = 11 + 5 = 16, correspondiente a la letra P."
  },
  {
    id: "psi_17",
    category: "Series Numéricas",
    battery: "Wonderlic",
    question: "¿Qué término completa la serie: 2, 3, 5, 7, 11, 13, 17, ...?",
    options: [
      "19 (secuencia estricta de números primos)",
      "21",
      "18"
    ],
    correct_index: 0,
    explanation: "La serie está conformada por los números primos consecutivos. El siguiente número primo después del 17 es el 19."
  },

  // ── 5. RAZONAMIENTO VERBAL Y ANALOGÍAS SEMÁNTICAS ──
  {
    id: "psi_18",
    category: "Analogías Verbales",
    battery: "Terman / Barsit",
    question: "BRÚJULA es a NAVEGACIÓN como CRONÓMETRO es a:",
    options: [
      "LONGITUD / TIEMPO (instrumento rector para determinación temporal y geográfica)",
      "VELOCIDAD",
      "PRESIÓN ATMOSFÉRICA"
    ],
    correct_index: 0,
    explanation: "La brújula es el instrumento de orientación angular náutica; el cronómetro de marina es el instrumento de precisión temporal indispensable para calcular la longitud geográfica."
  },
  {
    id: "psi_19",
    category: "Analogías Verbales",
    battery: "Terman / Barsit",
    question: "TIMÓN es a PROA como VOLANTE es a:",
    options: [
      "RUEDAS DELANTERAS (órgano de control y elemento directriz)",
      "MOTOR",
      "CHASIS"
    ],
    correct_index: 0,
    explanation: "El timón gobierna el rumbo de la embarcación orientando la dirección del buque, así como el volante dirige las ruedas directrices del vehículo."
  },
  {
    id: "psi_20",
    category: "Analogías Verbales",
    battery: "Terman / Barsit",
    question: "ESTRIBOR es a DERECHA como BABOR es a:",
    options: [
      "IZQUIERDA (nomenclatura náutica fundamental mirando hacia proa)",
      "POPA",
      "FONDO"
    ],
    correct_index: 0,
    explanation: "En la terminología naval universal, situándose el observador en la línea de crujía mirando hacia proa: estribor es la banda derecha y babor es la banda izquierda."
  },
  {
    id: "psi_21",
    category: "Analogías Verbales",
    battery: "Terman / Barsit",
    question: "Identifica el antónimo exacto de la palabra 'SUBORDINADO':",
    options: [
      "SUPERIOR / COMANDANTE",
      "COLABORADOR",
      "DISCIPLINADO"
    ],
    correct_index: 0,
    explanation: "Subordinado designa a quien depende de la autoridad de otro en la jerarquía; su antónimo directo es el superior o mando rector."
  },

  // ── 6. LÓGICA DEDUCTIVA Y SILOGISMOS MILITARES ──
  {
    id: "psi_22",
    category: "Lógica Deductiva",
    battery: "Razonamiento Formal",
    question: "Premisa 1: Todos los oficiales navales dominan cartas náuticas. Premisa 2: Ningún cadete indisciplinado domina cartas náuticas. ¿Qué conclusión lógica es irrefutable?",
    options: [
      "Ningún cadete indisciplinado es oficial naval",
      "Algunos cadetes indisciplinados son oficiales navales",
      "Todos los oficiales navales fueron cadetes indisciplinados"
    ],
    correct_index: 0,
    explanation: "Al tratarse de conjuntos disyuntos respecto al dominio de la cartografía náutica, es formalmente imposible que un elemento pertenezca al conjunto de oficiales y al de indisciplinados simultáneamente."
  },
  {
    id: "psi_23",
    category: "Lógica Deductiva",
    battery: "Razonamiento Formal",
    question: "Premisa 1: Todos los buques patrulla poseen radares de superficie. Premisa 2: La embarcación X no posee radar de superficie. ¿Qué conclusión es necesariamente verdadera?",
    options: [
      "La embarcación X no es un buque patrulla (Modus Tollens)",
      "La embarcación X es un submarino",
      "La embarcación X está en reparaciones"
    ],
    correct_index: 0,
    explanation: "Por inferencia deductiva Modus Tollens (Si P entonces Q; no Q, por tanto no P): si todo patrulla tiene radar y X no lo tiene, X no es buque patrulla."
  },
  {
    id: "psi_24",
    category: "Lógica Deductiva",
    battery: "Razonamiento Formal",
    question: "Cinco cadetes (A, B, C, D, E) marchan en fila india. B está delante de C pero detrás de A. D está delante de A. E está al final de la fila. ¿Quién ocupa el segundo lugar desde el frente?",
    options: [
      "El cadete A (orden de marcha: D, A, B, C, E)",
      "El cadete B",
      "El cadete D"
    ],
    correct_index: 0,
    explanation: "D está antes de A; A está antes de B; B está antes de C; E está al final. Por lo tanto el orden de vanguardia a retaguardia es: 1° D, 2° A, 3° B, 4° C, 5° E."
  },

  // ── 7. CÁLCULO CINEMÁTICO Y NAVEGACIÓN APLICADA ──
  {
    id: "psi_25",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Un buque patrulla oceánica zarpa a las 06:00 horas navegando a una velocidad de crucero constante de 18 nudos (1 nudo = 1 milla náutica por hora). ¿A qué distancia del puerto base se encontrará a las 11:30 horas si mantuvo rumbo directo?",
    options: [
      "99 millas náuticas (18 nudos * 5.5 horas transcurridas)",
      "90 millas náuticas",
      "108 millas náuticas"
    ],
    correct_index: 0,
    explanation: "Tiempo transcurrido = 5 horas y 30 minutos = 5.5 horas. Distancia = Velocidad * Tiempo = 18 * 5.5 = 99 millas náuticas."
  },
  {
    id: "psi_26",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Un helicóptero de búsqueda naval despega con autonomía de combustible para 4 horas. Vuela a 120 nudos hacia una zona de auxilio ubicada a 180 millas náuticas de distancia. ¿Cuánto tiempo máximo podrá permanecer patrullando la zona antes de tener que retornar a la base?",
    options: [
      "1 hora (ida 1.5 h + vuelta 1.5 h = 3 h de vuelo en tránsito; 4 h totales - 3 h = 1 h disponible)",
      "2 horas",
      "30 minutos"
    ],
    correct_index: 0,
    explanation: "Tiempo de vuelo ida = 180 mn / 120 nudos = 1.5 h. Tiempo de vuelo regreso = 1.5 h. Total de tránsito = 3.0 horas. De las 4 horas de combustible disponibles, le resta exactamente 1 hora para búsqueda y rescate en sitio."
  },
  {
    id: "psi_27",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Una guardia naval de puente dura exactamente 4 horas (un cuarto de guardia). Si un cadete debe cubrir 3 cuartos de guardia en un periodo de 36 horas, ¿qué porcentaje de ese tiempo total estuvo en servicio activo de guardia?",
    options: [
      "33.33% (12 horas de guardia entre 36 horas totales)",
      "25.00%",
      "40.00%"
    ],
    correct_index: 0,
    explanation: "3 cuartos * 4 horas/cuarto = 12 horas. 12 horas / 36 horas = 1/3 = 33.33%."
  },
  {
    id: "psi_28",
    category: "Velocidad Perceptiva",
    battery: "Beta-III / Precisión",
    question: "Identifica el par alfanumérico que presenta una discrepancia o error tipográfico mínimo entre ambas columnas:",
    options: [
      "SEMAR-HENM-2026-B94X  |  SEMAR-HENM-2026-B94X",
      "ARM-JUAREZ-PO-142-MX  |  ARM-JUAREZ-PO-142-NX (discrepancia en la penúltima letra: M vs N)",
      "VORTEX-ACADEMY-99011  |  VORTEX-ACADEMY-99011"
    ],
    correct_index: 1,
    explanation: "El segundo par contiene la discrepancia: el código de la izquierda termina en '-MX' mientras que el de la derecha culmina en '-NX'. Las pruebas de rapidez militar miden esta capacidad de discriminación en milisegundos."
  },
  {
    id: "psi_29",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "En una serie de tres figuras geométricas: la primera tiene 4 lados y 1 punto interior; la segunda tiene 5 lados y 2 puntos interiores; la tercera tiene 6 lados y 3 puntos interiores. ¿Qué características debe tener la cuarta figura?",
    options: [
      "7 lados (heptágono) y 4 puntos interiores (progresión coordinada +1 lado, +1 punto)",
      "8 lados y 3 puntos interiores",
      "6 lados y 5 puntos interiores"
    ],
    correct_index: 0,
    explanation: "Existe un incremento simultáneo de +1 lado del polígono exterior y +1 punto en el interior en cada posición consecutiva."
  },
  {
    id: "psi_30",
    category: "Aptitud Mecánica",
    battery: "Bennett / Mecánica Naval",
    question: "Dos recipientes comunicados por un tubo inferior (vasos comunicantes) contienen el mismo líquido homogéneo. El recipiente 1 tiene una sección transversal diez veces más ancha que el recipiente 2. ¿A qué altura relativa quedará el nivel del agua en ambos?",
    explanation: "En recipientes interconectados con un mismo fluido incompresible y abierto a la misma presión atmosférica, el nivel de la superficie libre se iguala independientemente de la forma geométrica o grosor de las ramas."
  },

  // ── 5. SERIES NUMÉRICAS Y PATRONES LÓGICOS (BETA-III / WONDERLIC) ──
  {
    id: "psi_31",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "¿Qué número continúa la serie lógica: 4, 9, 19, 39, 79, ...?",
    options: ["159 (regla: multiplicar por 2 y sumar 1)", "149", "169"],
    correct_index: 0,
    explanation: "Cada término se obtiene multiplicando el anterior por 2 y sumando 1: 4*2+1=9; 9*2+1=19; 19*2+1=39; 39*2+1=79; 79*2+1=159."
  },
  {
    id: "psi_32",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "Identifica el número faltante en la serie alterna: 2, 20, 4, 18, 8, 16, 16, 14, ¿...?",
    options: ["32 (la subserie impar se duplica: 2, 4, 8, 16, 32)", "12", "24"],
    correct_index: 0,
    explanation: "La serie contiene dos patrones intercalados: en posiciones impares (2, 4, 8, 16, 32) se multiplica por 2; en posiciones pares (20, 18, 16, 14) se resta 2. Corresponde posición impar: 16*2 = 32."
  },
  {
    id: "psi_33",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "¿Qué número completa la secuencia: 1, 1, 2, 3, 5, 8, 13, 21, ...?",
    options: ["34 (Sucesión de Fibonacci: cada término es la suma de los dos anteriores)", "29", "36"],
    correct_index: 0,
    explanation: "Sucesión de Fibonacci canónica: 13 + 21 = 34."
  },
  {
    id: "psi_34",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "Determina el valor de X e Y en la progresión: 3, 6, 12, 24, X, Y",
    options: ["X=48, Y=96 (progresión geométrica de razón 2)", "X=36, Y=48", "X=48, Y=72"],
    correct_index: 0,
    explanation: "Progresión geométrica de razón r=2: 24*2 = 48, y 48*2 = 96."
  },
  {
    id: "psi_35",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "¿Qué número rompe el patrón lógico en la serie: 3, 7, 15, 31, 64, 127?",
    options: ["64 (debería ser 63, pues la regla es 2n + 1)", "31", "15"],
    correct_index: 0,
    explanation: "La regla es multiplicar por 2 y sumar 1: 31*2+1 = 63, por lo que 64 es el número anómalo."
  },

  // ── 6. ORIENTACIÓN ESPACIAL Y VISTAS 3D ──
  {
    id: "psi_36",
    category: "Orientación Espacial",
    battery: "Desarrollo de Cuerpos 3D",
    question: "Al doblar una cruz formada por 6 cuadrados para construir un cubo, ¿qué cara quedará opuesta a la cara central si los brazos norte, sur, este y oeste se pliegan hacia arriba a 90° y el extremo sur se dobla para tapar?",
    options: ["El extremo sur (la tapa superior)", "El brazo este", "El brazo oeste"],
    correct_index: 0,
    explanation: "En el desarrollo de una cruz latina, la cara que se encuentra a dos casillas de distancia de la central se pliega como tapa opuesta paralela."
  },
  {
    id: "psi_37",
    category: "Orientación Espacial",
    battery: "Vistas Diédricas",
    question: "Un cono recto se proyecta sobre un plano horizontal desde arriba (planta) y sobre un plano frontal desde adelante (alzado). ¿Cuáles son sus dos vistas respectivas?",
    options: ["Círculo con punto central (planta) y Triángulo isósceles (alzado)", "Círculo y Rectángulo", "Dos círculos concéntricos"],
    correct_index: 0,
    explanation: "La vista superior de un cono es un círculo con su vértice en el centro; la vista frontal proyecta un triángulo isósceles cuya base es el diámetro y altura es la generatriz."
  },
  {
    id: "psi_38",
    category: "Orientación Espacial",
    battery: "Conteo de Bloques Isométricos",
    question: "Una pirámide de cubos sólidos consta de: 1 cubo en la cúspide (piso 3), apoyado sobre una base intermedia de 2x2 cubos (piso 2), apoyada sobre una base de 3x3 cubos (piso 1). ¿Cuántos cubos componen la estructura en total si no hay huecos interiores?",
    options: ["14 cubos (1 + 4 + 9 = 14)", "12 cubos", "16 cubos"],
    correct_index: 0,
    explanation: "Suma de los pisos cuadrados: Piso 1 (3x3 = 9) + Piso 2 (2x2 = 4) + Piso 3 (1x1 = 1) = 14 cubos totales."
  },
  {
    id: "psi_39",
    category: "Orientación Espacial",
    battery: "Rotación Mental 3D",
    question: "Una letra 'F' mayúscula se rota 180° en el plano y posteriormente se refleja en un espejo vertical a su derecha. ¿En qué posición final queda orientada?",
    options: ["Boca abajo mirando hacia la derecha", "Posición original normal", "Invertida horizontalmente únicamente"],
    correct_index: 0,
    explanation: "La rotación de 180° la deja boca abajo con los brazos apuntando a la izquierda; el reflejo vertical invierte el sentido horizontal de los brazos llevándolos a la derecha mientras permanece invertida verticalmente."
  },
  {
    id: "psi_40",
    category: "Orientación Espacial",
    battery: "Desarrollo de Prismas",
    question: "Un cilindro recto hueco se corta longitudinalmente por una de sus generatrices y se extiende sobre una mesa. ¿Qué figura geométrica plana exacta se obtiene?",
    options: ["Un rectángulo cuya base es igual a 2*pi*radio y altura igual a la generatriz", "Un trapecio escaleno", "Un paralelogramo oblicuo"],
    correct_index: 0,
    explanation: "El desarrollo de la superficie lateral de un cilindro recto es un rectángulo cuya longitud de base corresponde al perímetro de la directriz circular (2*pi*r) y su altura a la altura del cilindro."
  },

  // ── 7. APTITUD MECÁNICA Y FÍSICA NAVAL (BENNETT / TÉCNICO) ──
  {
    id: "psi_41",
    category: "Aptitud Mecánica",
    battery: "Bennett / Palancas",
    question: "En una palanca de primer género de 3 metros de longitud total, el punto de apoyo se ubica a 1 metro de una carga de 120 kg. ¿Qué fuerza mínima en el extremo opuesto (a 2 metros del apoyo) equilibra el sistema?",
    options: ["60 kg (Ley de la palanca: F1*d1 = F2*d2)", "120 kg", "40 kg"],
    correct_index: 0,
    explanation: "Fuerza * 2 m = 120 kg * 1 m -> Fuerza = 120 / 2 = 60 kg."
  },
  {
    id: "psi_42",
    category: "Aptitud Mecánica",
    battery: "Bennett / Hidrostática Naval",
    question: "Un buque patrullero navega desde agua dulce de río hacia mar abierto de alta salinidad. Suponiendo que su masa total no varía, ¿qué ocurrirá con el calado del buque (la profundidad sumergida del casco)?",
    options: ["El calado disminuirá levemente (el buque flota más alto debido a la mayor densidad del agua de mar)", "El calado aumentará", "El calado permanece idéntico"],
    correct_index: 0,
    explanation: "Principio de Arquímedes: Masa desplazada = Densidad * Volumen sumergido. Al ser el agua de mar más densa (~1025 kg/m³) que el agua dulce (1000 kg/m³), se requiere menor volumen de casco sumergido para igualar el peso, reduciendo el calado."
  },
  {
    id: "psi_43",
    category: "Aptitud Mecánica",
    battery: "Bennett / Poleas Compuestas",
    question: "Un polipasto factorial cuenta con 3 poleas fijas y 3 poleas móviles que sostienen una ancla de 600 kg. ¿Qué esfuerzo de tiro requiere el cabo para sostenerla sin fricción?",
    options: ["100 kg (la carga se divide entre 6 tramos de cabo que sustentan las poleas móviles: 600 / 6 = 100 kg)", "200 kg", "300 kg"],
    correct_index: 0,
    explanation: "En un aparejo con 'n' poleas móviles, la ventaja mecánica ideal es 2*n (aquí 2*3 = 6 ramales de soporte). Fuerza = Carga / 6 = 100 kg."
  },
  {
    id: "psi_44",
    category: "Aptitud Mecánica",
    battery: "Bennett / Transmisiones",
    question: "Dos ruedas están unidas por una banda o correa cruzada en 'X'. Si la rueda motriz gira en sentido de las manecillas del reloj, ¿en qué sentido girará la rueda conducida?",
    options: ["En sentido contrario a las manecillas del reloj (la correa cruzada invierte el sentido)", "En el mismo sentido de las manecillas del reloj", "Permanecerá inmóvil"],
    correct_index: 0,
    explanation: "Una correa abierta mantiene el sentido de giro; una correa cruzada en 'X' invierte el sentido de rotación entre ambos ejes."
  },
  {
    id: "psi_45",
    category: "Aptitud Mecánica",
    battery: "Bennett / Presión de Fluidos",
    question: "En una prensa hidráulica, el émbolo menor tiene un área de 5 cm² y el émbolo mayor tiene un área de 50 cm² (relación 1:10). Si se aplica una fuerza de 25 kg en el émbolo menor, ¿cuánta fuerza ascendente genera el mayor?",
    options: ["250 kg (Principio de Pascal: la fuerza se multiplica por la razón de áreas)", "50 kg", "500 kg"],
    correct_index: 0,
    explanation: "Presión P = F1/A1 = F2/A2. F2 = F1 * (A2/A1) = 25 kg * (50/5) = 25 * 10 = 250 kg."
  },

  // ── 8. CINEMÁTICA Y NAVEGACIÓN NAVAL ──
  {
    id: "psi_46",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Un buque patrullero costero navega a 18 nudos con rumbo norte. Recibe la orden de alcanzar una posición situada a 54 millas náuticas al norte. ¿Cuánto tiempo tardará en arribar?",
    options: ["3 horas exactas (54 mn / 18 nudos = 3 h)", "2.5 horas", "3.5 horas"],
    correct_index: 0,
    explanation: "1 nudo = 1 milla náutica por hora. Tiempo = Distancia / Velocidad = 54 / 18 = 3.0 horas."
  },
  {
    id: "psi_47",
    category: "Cálculo Naval",
    battery: "Rosa de los Vientos",
    question: "Un buque navega con rumbo este franco (090°). El timonel recibe la orden: 'Caer 45 grados a babor'. ¿Cuál es el nuevo rumbo de aguja?",
    options: ["045° (Noreste - babor es hacia la izquierda restando grados: 90° - 45° = 45°)", "135° (Sureste)", "000° (Norte)"],
    correct_index: 0,
    explanation: "Babor es el costado izquierdo de la embarcación viendo hacia proa; caer a babor reduce el ángulo de marcación: 090° - 45° = 045° (Noreste)."
  },
  {
    id: "psi_48",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Dos buques parten del mismo puerto al mismo tiempo: el Buque A navega hacia el Norte a 12 nudos y el Buque B navega hacia el Este a 16 nudos. ¿A qué distancia náutica en línea recta se encontrarán tras 1 hora de navegación?",
    options: ["20 millas náuticas (Teorema de Pitágoras: √(12² + 16²) = √(144+256) = √400 = 20)", "28 millas náuticas", "24 millas náuticas"],
    correct_index: 0,
    explanation: "Los rumbos Norte y Este son ortogonales (90°). Catetos de 12 mn y 16 mn. Hipotenusa = √(144 + 256) = √400 = 20 mn."
  },
  {
    id: "psi_49",
    category: "Cálculo Naval",
    battery: "Logística y Combustible",
    question: "Los tanques de diésel de una patrulla oceánica contienen 40,000 litros. Navegando a velocidad de crucero económica consume 400 litros por hora. ¿Cuál es su autonomía en días completos de navegación ininterrumpida?",
    options: ["4.16 días (100 horas continuas)", "5.50 días", "3.00 días"],
    correct_index: 0,
    explanation: "40,000 L / 400 L/h = 100 horas. 100 h / 24 h/día = 4.16 días (4 días y 4 horas)."
  },
  {
    id: "psi_50",
    category: "Cálculo Naval",
    battery: "Eco-sonda y Batimetría",
    question: "La ecosonda de un dragaminas emite un pulso ultrasónico vertical hacia el fondo del mar y recibe el eco de retorno exactamente 2 segundos después. Si la velocidad del sonido en agua salada es de 1,500 m/s, ¿a qué profundidad se encuentra el lecho marino?",
    options: ["1,500 metros (el pulso recorre ida y vuelta: distancia = (1500 * 2) / 2 = 1500 m)", "3,000 metros", "750 metros"],
    correct_index: 0,
    explanation: "El tiempo medido incluye ida y vuelta (t_total = 2 s, tiempo de ida = 1 s). Profundidad = Velocidad * (t / 2) = 1,500 m/s * 1 s = 1,500 metros."
  },

  // ── 9. RAZONAMIENTO ABSTRACTO Y ANALOGÍAS LÓGICAS (RAVEN / MATRICES) ──
  {
    id: "psi_51",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Una figura con forma de diamante se divide en 4 cuadrantes: en el cuadrante superior hay 1 círculo blanco; en el derecho 2 círculos blancos; en el inferior 3 círculos blancos. ¿Qué debe contener el cuadrante izquierdo para completar el ciclo rotacional?",
    options: ["4 círculos blancos", "1 círculo negro", "3 cuadrados"],
    correct_index: 0,
    explanation: "Existe un incremento secuencial en el sentido de las manecillas del reloj: 1, 2, 3 y 4 elementos idénticos."
  },
  {
    id: "psi_52",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Figura A es a Figura B (un triángulo equilátero que se invierte verticalmente y se pinta de negro), como Figura C (un pentágono con punta arriba blanco) es a:",
    options: ["Un pentágono con punta hacia abajo pintado de negro", "Un hexágono blanco", "Un pentágono invertido con marco punteado"],
    correct_index: 0,
    explanation: "La relación analógica aplica dos transformaciones: inversión vertical de 180° y cambio de relleno de blanco a negro sólido."
  },
  {
    id: "psi_53",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "En una fila de tres matrices: la primera tiene 4 flechas hacia la derecha; la segunda tiene 3 flechas a la derecha y 1 a la izquierda; la tercera tiene 2 a la derecha y 2 a la izquierda. ¿Cuál es la siguiente configuración lógica?",
    options: ["1 flecha a la derecha y 3 a la izquierda", "4 flechas a la izquierda de golpe", "2 flechas arriba y 2 abajo"],
    correct_index: 0,
    explanation: "En cada paso, una flecha orientada a la derecha se invierte hacia la izquierda de forma progresiva (4-0, 3-1, 2-2, 1-3)."
  },
  {
    id: "psi_54",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "¿Qué figura completa la matriz lógica de 2x2: Casilla 1: Cuadrado con círculo inscrito. Casilla 2: Cuadrado con círculo y triángulo concéntricos. Casilla 3: Círculo con cuadrado inscrito. Casilla 4: ¿...?",
    options: ["Círculo con cuadrado y triángulo concéntricos", "Cuadrado solo", "Triángulo con círculo"],
    correct_index: 0,
    explanation: "La regla de columna agrega un triángulo interior al polígono envolvente preexistente en la fila."
  },
  {
    id: "psi_55",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Identifica la figura intrusa: Cuadrado, Rombo, Rectángulo, Trapecio, Círculo.",
    options: ["El Círculo (es la única figura no poligonal sin aristas ni vértices rectos)", "El Trapecio", "El Rombo"],
    correct_index: 0,
    explanation: "Todas las figuras listadas son cuadriláteros poligonales de 4 segmentos rectos, salvo el círculo que es una curva cerrada continua."
  },

  // ── 10. APTITUD VERBAL Y ANALOGÍAS NAVALES ──
  {
    id: "psi_56",
    category: "Analogías Verbales",
    battery: "Wonderlic / Aptitud Verbal",
    question: "TIMÓN es a EMBARCACIÓN como VOLANTE es a:",
    options: ["AUTOMÓVIL (ambos son el elemento primario de gobierno direccional)", "LLANTA", "CARRETERA"],
    correct_index: 0,
    explanation: "Relación funcional análoga: el timón gobierna el rumbo de la embarcación del mismo modo que el volante gobierna el rumbo del automóvil."
  },
  {
    id: "psi_57",
    category: "Analogías Verbales",
    battery: "Wonderlic / Aptitud Verbal",
    question: "PROA es a POPA como:",
    options: ["VANGUARDIA es a RETAGUARDIA (extremo delantero vs extremo trasero)", "ESTRIBOR es a COSTADO", "MÁSTIL es a QUILLA"],
    correct_index: 0,
    explanation: "Proa y popa son los extremos anterior y posterior del buque; vanguardia y retaguardia son los extremos anterior y posterior de una formación táctica."
  },
  {
    id: "psi_58",
    category: "Analogías Verbales",
    battery: "Wonderlic / Aptitud Verbal",
    question: "ANCLA es a FONDEAR como CABO es a:",
    options: ["AMARRAR o HACER FIRME", "DESPRENDER", "NAVEGAR"],
    correct_index: 0,
    explanation: "Relación objeto-acción marinera: el ancla sirve para fondear el buque en el lecho marino; los cabos sirven para amarrarlo a los norays o bitas del muelle."
  },
  {
    id: "psi_59",
    category: "Analogías Verbales",
    battery: "Wonderlic / Aptitud Verbal",
    question: "Identifica el antónimo de la palabra 'EFÍMERO':",
    options: ["PERPETUO o DURADERO", "BREVE", "FUGAZ"],
    correct_index: 0,
    explanation: "Efímero significa de muy corta duración; su antónimo exacto es perpetuo, permanente o duradero."
  },
  {
    id: "psi_60",
    category: "Analogías Verbales",
    battery: "Wonderlic / Aptitud Verbal",
    question: "FARO es a NAVEGANTE como BRÚJULA es a:",
    options: ["EXPLORADOR (elemento de orientación y guía)", "MAPA", "DESTINO"],
    correct_index: 0,
    explanation: "El faro guía al navegante desde la costa; la brújula orienta al explorador en el terreno."
  },

  // ── 11. RAZONAMIENTO MECÁNICO AVANZADO Y FÍSICA APLICADA ──
  {
    id: "psi_61",
    category: "Aptitud Mecánica",
    battery: "Bennett / Centros de Gravedad",
    question: "¿En cuál de los dos buques es mayor la estabilidad transversal contra volcaduras (mayor par adrizante): un buque con la carga pesada estibada en el fondo de la bodega o un buque con la carga pesada en la cubierta superior?",
    options: ["En el buque con la carga en el fondo de la bodega (centro de gravedad bajo)", "En el buque con la carga en cubierta", "En ambos es exactamente igual"],
    correct_index: 0,
    explanation: "Al bajar los pesos a la sentina o fondo del casco, el centro de gravedad (G) desciende, aumentando la distancia metacéntrica (GM) y generando mayor brazo adrizante contra la zozobra."
  },
  {
    id: "psi_62",
    category: "Aptitud Mecánica",
    battery: "Bennett / Engranajes Cónicos",
    question: "Se utilizan dos engranajes cónicos a 90° para transmitir potencia entre el motor longitudinal y la hélice transversal de una embarcación menor. ¿Qué función mecánica primordial cumplen?",
    options: ["Cambiar en 90 grados la dirección del eje de rotación", "Duplicar la masa del fluido", "Detener el motor por inercia"],
    correct_index: 0,
    explanation: "Los engranajes cónicos tienen dientes tallados en superficies cónicas y se emplean específicamente para transmitir rotación entre ejes que se cruzan en ángulo (típicamente 90°)."
  },
  {
    id: "psi_63",
    category: "Aptitud Mecánica",
    battery: "Bennett / Fricción y Rodadura",
    question: "¿Qué requiere menor fuerza horizontal para desplazar un bloque de acero de 200 kg sobre concreto: arrastrarlo directamente con cadenas o colocar rodillos cilíndricos de madera debajo?",
    options: ["Colocar rodillos cilíndricos (la fricción por rodadura es notablemente menor que la fricción por deslizamiento)", "Arrastrarlo directamente", "La fuerza requerida es idéntica"],
    correct_index: 0,
    explanation: "El coeficiente de rozamiento por rodadura es un orden de magnitud inferior al coeficiente de rozamiento por deslizamiento seco."
  },
  {
    id: "psi_64",
    category: "Aptitud Mecánica",
    battery: "Bennett / Presión Atmosférica",
    question: "En lo alto de una montaña costera de 2,000 metros de altitud, ¿el agua hierve a mayor, menor o igual temperatura que al nivel del mar (Veracruz)?",
    options: ["Hierve a menor temperatura (alrededor de 93°C debido a la menor presión atmosférica)", "Hierve a mayor temperatura (a más de 105°C)", "Hierve exactamente a 100°C en cualquier altitud"],
    correct_index: 0,
    explanation: "A mayor altitud la presión atmosférica disminuye, por lo que la presión de vapor del agua iguala la presión ambiental a una temperatura inferior a los 100°C estándar del nivel del mar."
  },
  {
    id: "psi_65",
    category: "Aptitud Mecánica",
    battery: "Bennett / Hidrodinámica",
    question: "Según el Efecto Venturi, cuando agua fluye a través de un tubo que sufre un estrechamiento en su sección central, ¿qué ocurre con la velocidad del fluido y la presión estática en el cuello angosto?",
    options: ["La velocidad aumenta y la presión disminuye", "La velocidad disminuye y la presión aumenta", "Ambas se duplican"],
    correct_index: 0,
    explanation: "Por la ecuación de continuidad A1*V1 = A2*V2, al reducirse el área A2 la velocidad aumenta. Por el principio de Bernoulli, al aumentar la energía cinética la presión estática disminuye."
  },

  // ── 12. CÁLCULO NUMÉRICO Y CINEMÁTICA RÁPIDA ──
  {
    id: "psi_66",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Un radar naval detecta una embarcación sospechosa a 12 millas náuticas que se acerca de frente a 14 nudos. Si nuestro buque navega a su encuentro a 16 nudos en rumbos colineales encontrados, ¿en cuántos minutos se producirá el cruce?",
    options: ["24 minutos (Velocidad relativa de aproximación = 14 + 16 = 30 nudos. Tiempo = 12 / 30 h = 0.4 h = 24 min)", "30 minutos", "18 minutos"],
    correct_index: 0,
    explanation: "Al navegar al encuentro frontal, las velocidades se suman: V_relativa = 30 nudos. Tiempo = 12 mn / 30 mn/h = 0.4 horas = 24 minutos exactos."
  },
  {
    id: "psi_67",
    category: "Cálculo Naval",
    battery: "Aritmética Rápida",
    question: "En una dotación de 120 cadetes, el 65% aprueba natación de combate militar en la primera prueba. ¿Cuántos cadetes deben presentar examen extraordinario?",
    options: ["42 cadetes (el 35% de 120 = 120 * 0.35 = 42)", "38 cadetes", "48 cadetes"],
    correct_index: 0,
    explanation: "100% - 65% = 35% de no aprobados. 120 * 0.35 = 42 cadetes."
  },
  {
    id: "psi_68",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "1 milla náutica equivale oficialmente a 1,852 metros. Si una fragata avanza a 20 nudos durante 30 minutos, ¿cuántos kilómetros terrestres ha recorrido aproximadamente?",
    options: ["18.52 km (recorre 10 mn en media hora: 10 * 1,852 m = 18,520 m)", "20.00 km", "15.00 km"],
    correct_index: 0,
    explanation: "En media hora a 20 nudos avanza 10 millas náuticas. 10 * 1.852 km = 18.52 km."
  },
  {
    id: "psi_69",
    category: "Cálculo Naval",
    battery: "Aritmética Rápida",
    question: "¿Cuál es el resultado de la operación sin calculadora: (48 / 6) * 4 + 18 - (15 / 3)?",
    options: ["45 (8 * 4 + 18 - 5 = 32 + 18 - 5 = 45)", "42", "48"],
    correct_index: 0,
    explanation: "Jerarquía de operaciones: 48/6 = 8; 8*4 = 32; 15/3 = 5; 32 + 18 - 5 = 45."
  },
  {
    id: "psi_70",
    category: "Cálculo Naval",
    battery: "Logística y Raciones",
    question: "Un pañol de víveres cuenta con raciones para 80 marineros durante 15 días. Si se incorporan 20 marineros más a la dotación (total 100 personas), ¿para cuántos días alcanzarán exactamente las raciones?",
    options: ["12 días (Regla de tres inversa: 80 * 15 / 100 = 12 días)", "10 días", "13 días"],
    correct_index: 0,
    explanation: "Relación inversamente proporcional: a más personal, menos días de víveres. Días = (80 marineros * 15 días) / 100 marineros = 1200 / 100 = 12 días."
  },

  // ── 13. SERIES Y MATRICES COMPLEJAS (RAVEN / BETA-III) ──
  {
    id: "psi_71",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "En una cuadrícula 3x3: Fila 1 tiene figuras con 3 líneas rectas. Fila 2 tiene figuras con 4 líneas rectas. Fila 3 tiene dos figuras con 5 líneas rectas. ¿Qué debe tener la figura faltante?",
    options: ["5 líneas rectas (conservando el invariante de fila)", "6 líneas rectas", "4 líneas rectas"],
    correct_index: 0,
    explanation: "El invariante horizontal es el número constante de segmentos rectos que componen cada figura de la fila (3 en la primera, 4 en la segunda y 5 en la tercera)."
  },
  {
    id: "psi_72",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Un círculo se divide en 8 sectores (como una pizza). Una estrella negra se desplaza 3 sectores en sentido horario en cada paso. Si parte del sector 1, ¿en qué sector estará en el tercer paso?",
    options: ["Sector 7 (Paso 0: 1; Paso 1: 1+3=4; Paso 2: 4+3=7)", "Sector 6", "Sector 8"],
    correct_index: 0,
    explanation: "Secuencia de saltos de +3: sector 1 -> sector 4 -> sector 7."
  },
  {
    id: "psi_73",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "¿Qué figura rompe la regla de paridad: 2 triángulos unidos por el vértice, 4 cuadrados unidos por la arista, 6 hexágonos en panal, 7 círculos tangentes?",
    options: ["Los 7 círculos tangentes (es el único grupo de cantidad impar)", "Los 4 cuadrados", "Los 6 hexágonos"],
    correct_index: 0,
    explanation: "Los primeros tres elementos agrupan cantidades pares (2, 4, 6) mientras que el cuarto elemento rompe el patrón con una cifra impar (7)."
  },
  {
    id: "psi_74",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "¿Qué número continúa la serie de saltos cuadráticos: 1, 4, 9, 16, 25, 36, ...?",
    options: ["49 (serie de los cuadrados de los números naturales: 7² = 49)", "48", "54"],
    correct_index: 0,
    explanation: "1² = 1, 2² = 4, 3² = 9, 4² = 16, 5² = 25, 6² = 36, 7² = 49."
  },
  {
    id: "psi_75",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "Identifica el valor de Z en la secuencia: 100, 95, 85, 70, 50, Z",
    options: ["25 (la resta aumenta de 5 en 5: -5, -10, -15, -20, -25)", "30", "20"],
    correct_index: 0,
    explanation: "100 - 5 = 95; 95 - 10 = 85; 85 - 15 = 70; 70 - 20 = 50; 50 - 25 = 25."
  },

  // ── 14. ORIENTACIÓN ESPACIAL Y VISTAS TOPOGRÁFICAS ──
  {
    id: "psi_76",
    category: "Orientación Espacial",
    battery: "Cartografía Naval",
    question: "En una carta náutica con curvas de nivel batimétricas, cuando las líneas de profundidad se encuentran sumamente apretadas y juntas, ¿qué indica la topografía del fondo marino?",
    options: ["Un cantil o pendiente submarina muy pronunciada y abrupta", "Un fondo marino completamente plano", "Una barra de arena poco profunda y suave"],
    correct_index: 0,
    explanation: "En cualquier carta topográfica o batimétrica, la proximidad estrecha entre curvas de nivel sucesivas denota un cambio brusco de cota (pendiente pronunciada o acantilado)."
  },
  {
    id: "psi_77",
    category: "Orientación Espacial",
    battery: "Rotación Mental 3D",
    question: "Se observa un dado estándar donde las caras opuestas siempre suman 7 puntos. Si en la cara superior se encuentra el número 6 y en la cara frontal el número 2, ¿qué número está en la cara inferior y cuál en la posterior?",
    options: ["1 en la inferior y 5 en la posterior (6+1=7 y 2+5=7)", "3 en la inferior y 4 en la posterior", "2 en la inferior y 6 en la posterior"],
    correct_index: 0,
    explanation: "En un dado legal las caras opuestas suman 7: opuesta al 6 es 7-6 = 1 (inferior); opuesta al 2 es 7-2 = 5 (posterior)."
  },
  {
    id: "psi_78",
    category: "Orientación Espacial",
    battery: "Vistas Diédricas",
    question: "Una pieza metálica con forma de 'L' maciza se observa desde su lateral derecho. Si el brazo vertical mide el doble que el horizontal, ¿qué silueta proyecta?",
    options: ["Un rectángulo cuya altura es el doble de su ancho", "Un cuadrado perfecto", "Un trapecio escalonado"],
    correct_index: 0,
    explanation: "Al proyectar ortogonalmente desde el costado donde el ancho es uniforme, el perfil de la 'L' se comprime en un rectángulo de proporción 2:1."
  },
  {
    id: "psi_79",
    category: "Orientación Espacial",
    battery: "Conteo de Bloques Isométricos",
    question: "Se tiene un cubo grande de 3x3x3 cubitos pintado de gris en toda su superficie exterior. Si se desarma en los 27 cubitos individuales de 1x1x1, ¿cuántos cubitos tendrán exactamente 3 caras pintadas?",
    options: ["8 cubitos (únicamente los situados en los 8 vértices del cubo grande)", "6 cubitos", "12 cubitos"],
    correct_index: 0,
    explanation: "Solo los cubos ubicados en las 8 esquinas o vértices poseen 3 caras expuestas al exterior que reciben pintura."
  },
  {
    id: "psi_80",
    category: "Orientación Espacial",
    battery: "Conteo de Bloques Isométricos",
    question: "En el mismo cubo de 3x3x3 desmontado, ¿cuántos cubitos interiores no tendrán ninguna cara pintada (0 caras pintadas)?",
    options: ["1 cubito (el cubito central del núcleo: (3-2)³ = 1)", "3 cubitos", "0 cubitos"],
    correct_index: 0,
    explanation: "El núcleo interior no expuesto a ninguna cara exterior es (n-2)³ = (3-2)³ = 1 cubito."
  },

  // ── 15. RAZONAMIENTO MECÁNICO Y CIRCUITOS BÁSICOS ──
  {
    id: "psi_81",
    category: "Aptitud Mecánica",
    battery: "Bennett / Electricidad Básica",
    question: "Tres lámparas de emergencia idénticas de 12V se conectan en paralelo a una batería naval de 12V. Si una de las lámparas se funde, ¿qué ocurre con las otras dos?",
    options: ["Permanecen encendidas con el mismo brillo normal", "Se apagan inmediatamente", "Brillan con el triple de intensidad"],
    correct_index: 0,
    explanation: "En un circuito en paralelo, cada rama es independiente y mantiene la misma diferencia de potencial (voltaje); la desconexión de una rama no interrumpe el circuito de las restantes."
  },
  {
    id: "psi_82",
    category: "Aptitud Mecánica",
    battery: "Bennett / Palancas",
    question: "Un remo de una lancha ballenera se apoya en la toleteera del costado de la embarcación; el cadete aplica fuerza en el mango interior y la pala hace fuerza en el agua exterior. ¿Qué tipo de palanca representa respecto al agua como apoyo instantáneo?",
    options: ["Palanca de segundo género (la toleteera que empuja el buque es la resistencia situada entre el remero y el agua)", "Palanca de primer género", "Palanca de tercer género"],
    correct_index: 0,
    explanation: "Al remar, la pala fija momentáneamente el punto de apoyo en el agua, la resistencia que impulsa el buque está en la toleteera intermedia y la potencia la aplica el remero en el extremo."
  },
  {
    id: "psi_83",
    category: "Aptitud Mecánica",
    battery: "Bennett / Presión de Viento",
    question: "Un velero escuela navega recibiendo viento directo por la aleta de estribor. ¿Hacia qué costado tenderá a escorar (inclinarse) el buque de manera natural?",
    options: ["Hacia babor (el costado opuesto al de donde proviene la fuerza del viento)", "Hacia estribor", "Hacia proa únicamente"],
    correct_index: 0,
    explanation: "El empuje eólico transversal sobre el velamen empuja la obra muerta hacia la banda de sotavento (en este caso, babor)."
  },
  {
    id: "psi_84",
    category: "Aptitud Mecánica",
    battery: "Bennett / Gravedad y Caída Libre",
    question: "Dos esferas metálicas macizas de igual volumen, una de plomo (muy densa) y otra de aluminio (ligera), se dejan caer en un tubo al vacío desde la misma altura. ¿Cuál toca fondo primero?",
    options: ["Ambas tocan fondo en el mismo instante exacto (en el vacío la aceleración de gravedad 'g' es independiente de la masa)", "La esfera de plomo", "La esfera de aluminio"],
    correct_index: 0,
    explanation: "Experimento clásico de Galileo: en ausencia de resistencia del aire (vacío), todos los cuerpos experimentan la misma aceleración gravitatoria g = 9.81 m/s² y caen con idéntica velocidad."
  },
  {
    id: "psi_85",
    category: "Aptitud Mecánica",
    battery: "Bennett / Transmisión por Engranajes",
    question: "Un piñón de 10 dientes gira a 1,200 revoluciones por minuto y engrana con una rueda dentada de 40 dientes. ¿A qué velocidad de rotación gira la rueda conducida?",
    options: ["300 RPM (relación de reducción 4:1 -> 1200 / 4 = 300 RPM)", "4,800 RPM", "600 RPM"],
    correct_index: 0,
    explanation: "Relación de transmisión: N1 * Z1 = N2 * Z2. N2 = (1200 RPM * 10 dientes) / 40 dientes = 12000 / 40 = 300 RPM."
  },

  // ── 16. PRECISIÓN Y DISCRIMINACIÓN PERCEPTIVA RÁPIDA (BETA-III) ──
  {
    id: "psi_86",
    category: "Velocidad Perceptiva",
    battery: "Beta-III / Precisión",
    question: "Localiza el grupo de coordenadas náuticas que contiene un error de transcripción:",
    options: [
      "Lat 19°12'45\"N, Long 096°08'12\"W  |  Lat 19°12'45\"N, Long 096°08'12\"W",
      "Lat 21°30'00\"N, Long 089°45'10\"W  |  Lat 21°30'00\"N, Long 089°46'10\"W (error en los minutos de Longitud: 45 vs 46)",
      "Lat 31°51'28\"N, Long 116°36'21\"W  |  Lat 31°51'28\"N, Long 116°36'21\"W"
    ],
    correct_index: 1,
    explanation: "En la segunda opción la longitud en el segundo término dice 46 minutos en lugar de 45 minutos."
  },
  {
    id: "psi_87",
    category: "Velocidad Perceptiva",
    battery: "Beta-III / Precisión",
    question: "¿Cuántas veces aparece la letra 'M' en la siguiente cadena: X M V M W N M M V W M N M W M?",
    options: ["7 veces", "6 veces", "8 veces"],
    correct_index: 0,
    explanation: "Contando con precisión: M(1), M(2), M(3), M(4), M(5), M(6), M(7). Aparece exactamente 7 veces (evitando confundirla con las letras W y N)."
  },
  {
    id: "psi_88",
    category: "Velocidad Perceptiva",
    battery: "Beta-III / Precisión",
    question: "Identifica el código idéntico al modelo de referencia: [SEMAR-ARM-902-DELTA]",
    options: [
      "SEMAR-ARM-902-DELTA (coincidencia perfecta de caracteres y guiones)",
      "SEMAR-ARM-920-DELTA",
      "SENAR-ARM-902-DELTA"
    ],
    correct_index: 0,
    explanation: "La opción 1 reproduce el patrón original sin transposición numérica (902 vs 920) ni cambio tipográfico (M vs N)."
  },

  // ── 17. PROBLEMAS DE LÓGICA Y RESOLUCIÓN TÁCTICA ──
  {
    id: "psi_89",
    category: "Razonamiento Lógico",
    battery: "Wonderlic / Juicio Lógico",
    question: "Todos los oficiales de cubierta saben navegar a vela. Ningún cadete de nuevo ingreso sabe navegar a vela. Por lo tanto:",
    options: ["Ningún cadete de nuevo ingreso es oficial de cubierta", "Algunos oficiales de cubierta son cadetes nuevos", "Todos los oficiales de cubierta son cadetes"],
    correct_index: 0,
    explanation: "Silogismo categórico válido (Modo Camestres): si el conjunto de oficiales de cubierta está contenido en los que saben navegar a vela y los cadetes de nuevo ingreso están excluidos de ese conjunto, la intersección entre ambos es vacía."
  },
  {
    id: "psi_90",
    category: "Razonamiento Lógico",
    battery: "Wonderlic / Juicio Lógico",
    question: "Si ayer hubiese sido mañana, hoy sería viernes. ¿Qué día de la semana es hoy realmente?",
    options: ["Domingo (si hoy es domingo, ayer fue sábado; si ese sábado hubiese sido mañana, hoy sería viernes)", "Miércoles", "Sábado"],
    correct_index: 0,
    explanation: "Acertijo temporal clásico: para que el día anterior equivalga a mañana respecto al viernes, la fecha real actual debe ser domingo."
  },
  {
    id: "psi_91",
    category: "Razonamiento Lógico",
    battery: "Wonderlic / Juicio Lógico",
    question: "En una fila militar de 5 cadetes: Alberto está a la izquierda de Bernardo. Carlos está a la derecha de Bernardo. David está entre Alberto y Bernardo. ¿Quién se encuentra en el extremo izquierdo de la formación?",
    options: ["Alberto", "David", "Carlos"],
    correct_index: 0,
    explanation: "Orden de izquierda a derecha según las premisas: Alberto -> David -> Bernardo -> Carlos. En el extremo izquierdo está Alberto."
  },
  {
    id: "psi_92",
    category: "Razonamiento Lógico",
    battery: "Wonderlic / Juicio Lógico",
    question: "Un buque patrullero tiene víveres suficientes para alimentar a su tripulación de 60 elementos durante 30 días. Si transcurren 10 días normales de navegación y luego rescata a 20 náufragos, ¿cuántos días más durará el suministro de alimentos?",
    options: ["15 días más (a 60 hombres les quedaban 20 días: 60*20 / 80 hombres = 15 días)", "12 días", "18 días"],
    correct_index: 0,
    explanation: "A los 10 días quedan víveres para 60 tripulantes durante 20 días = 1,200 raciones. Con 80 personas (60+20): 1,200 / 80 = 15 días."
  },

  // ── 18. MATRICES FINALES Y CINEMÁTICA AVANZADA ──
  {
    id: "psi_93",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Una rueda tiene marcados 4 cuadrantes pintados de colores: Rojo, Azul, Verde y Amarillo en sentido horario. Si la rueda gira 270° en sentido antihorario, ¿dónde se ubica el cuadrante Rojo que originalmente estaba en el norte (arriba)?",
    options: ["Al Este (a la derecha: girar 270° antihorario equivale a girar 90° horario)", "Al Oeste (a la izquierda)", "Al Sur (abajo)"],
    correct_index: 0,
    explanation: "Una rotación de 270° en sentido contrario a las manecillas del reloj equivale exactamente a una rotación de 90° en sentido horario (360° - 270° = 90°). Desde el Norte, 90° horario es el Este."
  },
  {
    id: "psi_94",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Un helicóptero naval Panther vuela a 140 nudos. ¿Cuántas millas náuticas recorre en 15 minutos exactos?",
    options: ["35 millas náuticas (15 min = 0.25 h; 140 * 0.25 = 35 mn)", "40 millas náuticas", "30 millas náuticas"],
    correct_index: 0,
    explanation: "15 minutos representan 1/4 de hora (0.25 h). Distancia = 140 nudos * 0.25 h = 35 millas náuticas."
  },
  {
    id: "psi_95",
    category: "Aptitud Mecánica",
    battery: "Bennett / Centros de Gravedad",
    question: "¿En cuál de las tres posiciones tiene mayor estabilidad una campana de buceo cilíndrica maciza: de pie vertical, inclinada a 45° o acostada horizontalmente sobre el fondo marino?",
    options: ["Acostada horizontalmente (su centro de gravedad se encuentra a la menor altura posible y máxima base de apoyo)", "De pie vertical", "Inclinada a 45°"],
    correct_index: 0,
    explanation: "Un cuerpo rígido alcanza su equilibrio más estable cuando la altura de su centro de gravedad respecto a la superficie de apoyo es mínima."
  },
  {
    id: "psi_96",
    category: "Series Numéricas",
    battery: "Beta-III / Razonamiento Lógico",
    question: "¿Cuál es el valor que falta en la secuencia fraccionaria: 1/2, 3/4, 7/8, 15/16, ¿...?",
    options: ["31/32 (el numerador es 2^n - 1 y el denominador es 2^n con n=5: 31/32)", "23/24", "30/32"],
    correct_index: 0,
    explanation: "Los denominadores son potencias de 2 (2, 4, 8, 16, 32); los numeradores son una unidad menores que su respectivo denominador (32 - 1 = 31). Fracción = 31/32."
  },
  {
    id: "psi_97",
    category: "Analogías Verbales",
    battery: "Wonderlic / Aptitud Verbal",
    question: "ESTRIBOR es a DERECHA como BABOR es a:",
    options: ["IZQUIERDA (término náutico oficial para la banda izquierda del buque)", "FRENTE", "ATRÁS"],
    correct_index: 0,
    explanation: "En nomenclatura marinera universal: Estribor corresponde a la banda derecha y Babor a la banda izquierda mirando de popa hacia proa."
  },
  {
    id: "psi_98",
    category: "Aptitud Mecánica",
    battery: "Bennett / Rozamiento en Cuerdas",
    question: "Al amarrar un buque a un noray del muelle, ¿por qué los marineros dan 3 o 4 vueltas con el cabo alrededor de la bita antes de hacer el cote?",
    options: ["Porque cada vuelta multiplica exponencialmente la fricción (efecto cabestrante de Euler-Eytelwein), reduciendo la fuerza necesaria para sostener toneladas a unos pocos kilos manuales", "Por simple tradición decorativa", "Para que el cabo no se moje"],
    correct_index: 0,
    explanation: "Ecuación de Euler-Eytelwein del cabrestante: T_firme = T_tiro * e^(coef_friccion * angulo). Con 3 vueltas completas (6*pi radianes), una fuerza de retención manual de 20 kg puede frenar fácilmente una tensión de varias toneladas."
  },
  {
    id: "psi_99",
    category: "Cálculo Naval",
    battery: "Cinemática Náutica",
    question: "Un buque hidrográfico mide un meridiano náutico. Sabiendo que 1 minuto de arco de latitud equivale por definición náutica a 1 milla náutica (1,852 metros), ¿cuántas millas náuticas mide un grado completo de latitud terrestre?",
    options: ["60 millas náuticas (1 grado = 60 minutos de arco = 60 mn)", "100 millas náuticas", "360 millas náuticas"],
    correct_index: 0,
    explanation: "El sistema sexagesimal divide 1 grado en 60 minutos de arco; por definición geodésica náutica, 1 minuto de arco de meridiano terrestre = 1 milla náutica. Por tanto, 1° de latitud = 60 millas náuticas (~111.12 km)."
  },
  {
    id: "psi_100",
    category: "Razonamiento Abstracto",
    battery: "Raven / Matrices",
    question: "Se combinan tres operaciones lógicas sucesivas sobre una figura geométrica: 1) Rotar 90° a la derecha; 2) Invertir los colores blanco/negro; 3) Superponer una diagonal desde la esquina inferior izquierda a la superior derecha. Si se aplica sobre un cuadrado blanco con un círculo negro en el cuadrante superior derecho, ¿cuál es el resultado final?",
    options: [
      "Cuadrado negro con un círculo blanco en el cuadrante inferior derecho, cruzado por una diagonal",
      "Cuadrado blanco sin círculo",
      "Círculo negro con cruz central"
    ],
    correct_index: 0,
    explanation: "Paso 1: el círculo negro rota del superior derecho al inferior derecho. Paso 2: el fondo se vuelve negro y el círculo se vuelve blanco. Paso 3: se superpone la diagonal especificada."
  }
];

